/*
 * Copyright (c) 2020.
 * Simon
 */

import {toast} from "react-toastify";
import i18n from "i18next";

/**
 |--------------------------------------------------
 | CHECK CAN CLICK OR NOT
 |--------------------------------------------------
 */


export default function isTime2Click(clickName, delay = 1000) {
    let currentTime = new Date().getTime();

    let lastClick = parseInt(localStorage.getItem(clickName));

    let dif = currentTime - lastClick;
    if (dif < delay) {
        if (! toast.isActive(global.clickTooFast)) {
            global.clickTooFast = toast.info(i18n.t("You click too fast"),{autoClose: 1200});
        }


        localStorage.setItem(clickName, currentTime.toString());
        return false;
    }

    localStorage.setItem(clickName, currentTime.toString());
    return true;
}
